// @flow
import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

import * as st from './TextBlock.module.scss'

export const TextBlock: React.ComponentType<BaseComponentProps> = (props) => {
  const className = extractClassNamesFromProps(props, st.container)
  return (<div className={className}>{props.children}</div>)
}

// Add displayName to preserve the component name on snapshot testing
TextBlock.displayName = 'TextBlock'
